import { request } from '../sharedLegacy/utils'

// This is supposed to grow with time

export const getLiveData = async (liveId, liveToken, options) => {
  const url = '/api/live/list'
  const data = {
    live_id: liveId,
    ...options,
  }

  if (liveToken) {
    data.token = liveToken
  }

  const { firstlive } = await request({
    url,
    method: 'GET',
    data,
  })

  return firstlive
}
